// src/services/axios.js
import axios from 'axios';
import { assertApiDestination } from '@/utils/apiDestination';

const envVite = (typeof import.meta !== 'undefined' && import.meta.env) ? import.meta.env : {};
let BASE_URL =
  (typeof process !== 'undefined' && process.env && process.env.VUE_APP_API_URL)
  || envVite.VITE_API_BASE_URL
  || '';

try {
  const isDevServer =
    typeof window !== 'undefined'
    && window.location
    && window.location.port === '8080';
  if ((!BASE_URL || BASE_URL === '/api') && isDevServer) {
    BASE_URL = 'http://localhost:3001';
  }
} catch (e) {
  // ignore: ambiente sem window/import.meta
}

const instance = axios.create({
  baseURL: BASE_URL || '/api',
});

instance.interceptors.request.use((config) => {
  assertApiDestination(config, instance.defaults.baseURL, window.location.href);
  const token = localStorage.getItem('token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Debug: confirme a base no console
// Deve ser "http://localhost:3001" no DEV rápido
console.info('[axios] baseURL =', instance.defaults.baseURL);

export default instance;
